import React from 'react';
import ArticleQA from './ArticleQA';
import './ArticleViewer.css';

/**
 * ArticleViewer Component
 * Renders article content with proper formatting and optional Q&A section
 */
const ArticleViewer = ({ title, content, children, showQA = false, articleId = null }) => {
  return (
    <article className="article-viewer">
      {title && (
        <header className="article-viewer-header">
          <h1 className="lp-section-title">{title}</h1>
        </header>
      )}
      <div className="article-viewer-content">
        {content ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          children
        )}
      </div>
      {showQA && <ArticleQA articleId={articleId} />}
    </article>
  );
};

export default ArticleViewer;
